/* Levaro theme JS — Hero slider, mobile menu, product gallery, quantity, variants */

(function () {
  'use strict';

  /* ---------- Hero Slider ---------- */
  const slider = document.querySelector('[data-hero-slider]');
  if (slider) {
    const slides = slider.querySelectorAll('[data-hero-slide]');
    const dots = slider.querySelectorAll('[data-hero-dot]');
    const prev = slider.querySelector('[data-hero-prev]');
    const next = slider.querySelector('[data-hero-next]');
    let index = 0;
    let autoplay;

    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    }
    function start() {
      stop();
      if (slides.length > 1) autoplay = setInterval(() => go(index + 1), 6000);
    }
    function stop() { clearInterval(autoplay); }

    dots.forEach((d, n) => d.addEventListener('click', () => { go(n); start(); }));
    if (prev) prev.addEventListener('click', () => { go(index - 1); start(); });
    if (next) next.addEventListener('click', () => { go(index + 1); start(); });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    start();
  }

  /* ---------- Mobile menu ---------- */
  const menuToggle = document.querySelector('[data-mobile-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  const menuClose = document.querySelector('[data-mobile-close]');
  if (menuToggle && menu) {
    menuToggle.addEventListener('click', () => menu.classList.add('is-open'));
  }
  if (menuClose && menu) {
    menuClose.addEventListener('click', () => menu.classList.remove('is-open'));
  }

  /* ---------- Product gallery ---------- */
  const gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    const main = gallery.querySelector('[data-gallery-main] img');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(t => {
      t.addEventListener('click', () => {
        const src = t.dataset.image;
        if (main && src) main.src = src;
        thumbs.forEach(x => x.classList.remove('is-active'));
        t.classList.add('is-active');
      });
    });
  }

  /* ---------- Quantity ---------- */
  document.querySelectorAll('[data-quantity]').forEach(q => {
    const input = q.querySelector('input');
    const minus = q.querySelector('[data-qty-minus]');
    const plus = q.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', () => {
      const v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (plus) plus.addEventListener('click', () => {
      const v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  });

  /* ---------- Variant pill picker (single-option simple) ---------- */
  document.querySelectorAll('[data-variant-group]').forEach(group => {
    const pills = group.querySelectorAll('[data-variant-pill]');
    const select = document.querySelector(group.dataset.select);
    pills.forEach(p => {
      p.addEventListener('click', () => {
        pills.forEach(x => x.classList.remove('is-active'));
        p.classList.add('is-active');
        if (select) {
          select.value = p.dataset.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });
})();

/* ============================================================
   ANNOUNCEMENT BAR — Auto-Rotate
   Ans Ende deiner assets/theme.js anhängen.
   ============================================================ */
(function () {
  'use strict';
  var bar = document.querySelector('[data-announcement-bar]');
  if (!bar) return;
  var slides = bar.querySelectorAll('[data-announcement-slide]');
  if (slides.length <= 1) return;

  var idx = 0;
  var interval = 4000;

  function go(n) {
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === n); });
    idx = n;
  }

  setInterval(function () {
    go((idx + 1) % slides.length);
  }, interval);
})();

(() => {
  if (window.etreGallerySwipeLoaded) return;
  window.etreGallerySwipeLoaded = true;

  const mobile = window.matchMedia('(max-width: 900px)');

  function initGallery(gallery) {
    if (gallery.dataset.swipeReady === 'true') return;

    const main = gallery.querySelector('[data-gallery-main]');
    const buttons = Array.from(
      gallery.querySelectorAll('[data-gallery-thumb]')
    );

    if (!main || !main.querySelector('img') || buttons.length < 2) {
      return;
    }

    gallery.dataset.swipeReady = 'true';
    main.style.touchAction = 'pan-y pinch-zoom';

    const title = gallery.closest('.product')
      ?.querySelector('.product-info__title')
      ?.textContent.trim() || document.title;

    function syncDots() {
      buttons.forEach(button => {
        button.setAttribute(
          'aria-pressed',
          String(button.classList.contains('is-active'))
        );
      });
    }

    function show(index) {
      const button = buttons[index];
      const image = main.querySelector('img');

      if (!image || !button?.dataset.image) return;

      image.removeAttribute('srcset');
      image.src = button.dataset.image;
      image.alt = button.querySelector('img')?.alt || title;

      buttons.forEach((item, i) => {
        item.classList.toggle('is-active', i === index);
      });

      syncDots();
    }

    buttons.forEach((button, index) => {
      if (!button.hasAttribute('aria-label')) {
        button.setAttribute(
          'aria-label',
          `${title} – ${index + 1} / ${buttons.length}`
        );
      }

      button.addEventListener('click', () => show(index));
    });

    new MutationObserver(syncDots).observe(gallery, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });

    syncDots();

    let gesture = null;

    main.addEventListener('touchstart', event => {
      gesture = null;

      if (!mobile.matches || event.touches.length !== 1) return;

      const touch = event.touches[0];

      gesture = {
        id: touch.identifier,
        x: touch.clientX,
        y: touch.clientY
      };
    }, { passive: true });

    main.addEventListener('touchmove', event => {
      if (!gesture) return;

      if (event.touches.length !== 1) {
        gesture = null;
        return;
      }

      const touch = event.touches[0];
      const dx = touch.clientX - gesture.x;
      const dy = touch.clientY - gesture.y;

      if (
        touch.identifier !== gesture.id ||
        (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx))
      ) {
        gesture = null;
      }
    }, { passive: true });

    main.addEventListener('touchend', event => {
      const start = gesture;
      gesture = null;

      if (
        !start ||
        !mobile.matches ||
        event.touches.length !== 0
      ) {
        return;
      }

      const touch = Array.from(event.changedTouches)
        .find(item => item.identifier === start.id);

      if (!touch) return;

      const dx = touch.clientX - start.x;
      const dy = touch.clientY - start.y;

      if (
        Math.abs(dx) < 40 ||
        Math.abs(dx) < Math.abs(dy) * 1.3
      ) {
        return;
      }

      const current = buttons.findIndex(button =>
        button.classList.contains('is-active')
      );

      const direction = dx < 0 ? 1 : -1;

      const next = current < 0
        ? 0
        : (current + direction + buttons.length) % buttons.length;

      show(next);
    }, { passive: true });

    main.addEventListener('touchcancel', () => {
      gesture = null;
    }, { passive: true });
  }

  function scan(scope) {
    scope.querySelectorAll('[data-product-gallery]')
      .forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => scan(document),
      { once: true }
    );
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', event => {
    scan(event.target);
  });
})();

(() => {
  if (window.etreDesktopScrollLoaded) return;
  window.etreDesktopScrollLoaded = true;

  const desktop = window.matchMedia('(min-width: 901px)');
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );
  const instances = new Map();

  function init(gallery) {
    if (instances.has(gallery)) return;

    const product = gallery.closest('.product');
    const mainImage = gallery.querySelector('[data-gallery-main] img');
    const rail = gallery.querySelector('.product-gallery__thumbs');
    const buttons = [
      ...gallery.querySelectorAll('[data-gallery-thumb]')
    ];

    if (!product || !mainImage || !rail || buttons.length < 2) return;
    if (buttons.some(button => !button.dataset.image)) return;

    const info = product.querySelector('.product-info');
    const header = document.querySelector('.site-header');

    const title = product
      .querySelector('.product-info__title')
      ?.textContent.trim() || document.title;

    const controller = new AbortController();
    const signal = controller.signal;

    let stack;
    let slides = [];
    let frame = 0;

    function activeIndex() {
      return Math.max(
        0,
        buttons.findIndex(button =>
          button.classList.contains('is-active')
        )
      );
    }

    function build() {
      if (stack) return;

      stack = document.createElement('div');
      stack.className = 'etre-desktop-images';

      slides = buttons.map((button, index) => {
        const slide = document.createElement('figure');
        slide.className = 'etre-desktop-image';

        const image = document.createElement('img');

        image.width = mainImage.width || 800;
        image.height = mainImage.height || 1066;
        image.loading = index === activeIndex() ? 'eager' : 'lazy';
        image.decoding = 'async';

        image.alt = button.querySelector('img')?.alt ||
          `${title} – ${index + 1} / ${buttons.length}`;

        image.src = button.dataset.image;

        slide.append(image);
        return slide;
      });

      const first = activeIndex();

      const order = [
        first,
        ...buttons.map((_, i) => i).filter(i => i !== first)
      ];

      order.forEach((index, position) => {
        stack.append(slides[index]);

        buttons[index].style.setProperty(
          '--etre-desktop-order',
          position
        );
      });

      gallery.append(stack);
      gallery.classList.add('etre-desktop-scroll');
      product.classList.add('etre-scroll-layout');
    }

    function offset() {
      const top = Math.max(
        16,
        (header?.getBoundingClientRect().bottom || 0) + 16
      );

      product.style.setProperty('--etre-gallery-top', `${top}px`);

      if (info) {
        const infoTop = Math.min(
          top,
          window.innerHeight - info.getBoundingClientRect().height - 16
        );

        product.style.setProperty('--etre-info-top', `${infoTop}px`);
      }

      return top;
    }

    function activate(index) {
      buttons.forEach((button, i) => {
        const active = i === index;

        if (button.classList.contains('is-active') !== active) {
          button.classList.toggle('is-active', active);
        }

        button.setAttribute('aria-pressed', String(active));
      });

      const item = buttons[index].getBoundingClientRect();
      const bounds = rail.getBoundingClientRect();

      if (item.top < bounds.top) {
        rail.scrollTop += item.top - bounds.top;
      } else if (item.bottom > bounds.bottom) {
        rail.scrollTop += item.bottom - bounds.bottom;
      }
    }

    function go(index) {
      if (!desktop.matches || !slides[index]) return;

      const top = offset();
      activate(index);

      window.scrollTo({
        top: Math.max(
          0,
          window.scrollY + slides[index].getBoundingClientRect().top - top
        ),
        behavior: reducedMotion.matches ? 'instant' : 'smooth'
      });
    }

    function update() {
      frame = 0;

      if (!desktop.matches || !stack) return;

      const top = offset();
      const bounds = stack.getBoundingClientRect();

      if (bounds.bottom <= top || bounds.top >= window.innerHeight) {
        return;
      }

      const line = top + Math.min(
        200,
        (window.innerHeight - top) / 3
      );

      let nearest = 0;
      let distance = Infinity;

      slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();

        const value = Math.max(
          rect.top - line,
          line - rect.bottom,
          0
        );

        if (value < distance) {
          distance = value;
          nearest = index;
        }
      });

      activate(nearest);
    }

    function schedule() {
      if (!frame) {
        frame = requestAnimationFrame(update);
      }
    }

    function modeChanged() {
      if (desktop.matches) {
        build();
        schedule();
      } else if (stack) {
        const index = activeIndex();

        mainImage.removeAttribute('srcset');
        mainImage.src = buttons[index].dataset.image;
        mainImage.alt = slides[index].querySelector('img').alt;
      }
    }

    gallery.addEventListener('click', event => {
      if (!desktop.matches) return;

      const button = event.target.closest('[data-gallery-thumb]');
      const index = buttons.indexOf(button);

      if (index < 0) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      go(index);
    }, { capture: true, signal });

    const observer = new MutationObserver(() => {
      if (desktop.matches && stack) {
        go(activeIndex());
      }
    });

    observer.observe(mainImage, {
      attributes: true,
      attributeFilter: ['src']
    });

    const resize = new ResizeObserver(schedule);

    resize.observe(product);
    if (info) resize.observe(info);

    window.addEventListener('scroll', schedule, {
      passive: true,
      signal
    });

    window.addEventListener('resize', schedule, {
      passive: true,
      signal
    });

    desktop.addEventListener('change', modeChanged, { signal });

    instances.set(gallery, () => {
      controller.abort();
      observer.disconnect();
      resize.disconnect();
      cancelAnimationFrame(frame);
      instances.delete(gallery);
    });

    modeChanged();
  }

  function scan(scope) {
    scope.querySelectorAll('[data-product-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => scan(document),
      { once: true }
    );
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', event => {
    scan(event.target);
  });

  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, gallery) => {
      if (event.target.contains(gallery)) cleanup();
    });
  });
})();

